export default __webpack_public_path__ + "static/media/startupRealCase2-mobile.c53f41f7.jpg";